import React, {PropTypes} from "react";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import {RadioButtonGroup} from "material-ui/RadioButton";
import {hashHistory} from 'react-router';
import axios from 'axios';
import toastr from 'toastr';


class DogFoodingModal extends React.Component {

  constructor() {
    super();
    this.state={status: "inactive"};

  }
  componentDidMount()
  {
    // axios.get(process.env.REQ_URL + "/chatter/myDogFooding", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
    //   console.log(response.data.data);
    //   this.setState({status: response.data.data});
    // }).catch((error) => {
    //
    // });


  }
  componentWillReceiveProps()
  {

  }


  render() {
    let  actions=[];
    if(this.state.status=='inactive')
    {
     actions = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onTouchTap={this.props.close}
      />,
      <RaisedButton
        style={{marginLeft: '20px'}}
        label="Sign Up"
        primary={true}
        keyboardFocused={true}
        onTouchTap={()=> {
          axios.post(process.env.REQ_URL + "/chatter/subscribeDogFooding",{}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
            toastr.success("Subscribed");
            hashHistory.push("/1/announcements/quikrInspectr")
            this.props.close();

          }).catch((error) => {

          });



          //api call
        }}
      />,
    ];}
    else
       actions = [
        <RaisedButton
          label="Cancel"
          primary={true}
          onTouchTap={this.props.close}
        />,
        <RaisedButton
          style={{marginLeft: '20px'}}
          label="Already Subscribed"
          primary={true}
          disabled={true}
        />,
      ];

    return (
      <Dialog
        title="Welcome to the Quikr Inspection program."
        titleStyle={{color: 'white',backgroundColor: '#008bcf'}}

        actions={actions}
        modal={false}
        open={this.props.open}
        onRequestClose={this.props.close}

      >
        <h2>Signing up allows you to:</h2><br/>
        1. Have the freedom to easily share products & ideas that are still in beta, with people across the entire organization. This can help you get valuable feedback from users across departments & locations before your launch date so that the end-product is the most refined and user friendly version.  While creating an Inspection, always remember to include a Google Survey link for people to give their feedback - you decide how detailed these responses should be!<br/><br/>
        2. Receive Inspection-ideas from other Quikrites right in your inbox! You'll be at the front-line of testing out nascent concepts & your feedback will be valuable in improving the overall quality of our entire platform."
        <br/>
        <br/>
        Become a Quikr Inspectr! Test out new features, ready to be launched and give your feedback right back to the team spearheading the launch. Your opinions matter so inspect well!
        <RadioButtonGroup name="shipSpeed" defaultSelected="not_light">

        </RadioButtonGroup>
      </Dialog>
    );
  }
}

DogFoodingModal.propTypes = {};

export default DogFoodingModal;





/** WEBPACK FOOTER **
 ** ./src/components/Home/DogFoodingModal.js
 **/